import { Client, Storage } from 'appwrite';

// Initialize a new Appwrite client for the cloud project
const cloudAppwriteClient = new Client();

cloudAppwriteClient
  .setEndpoint('https://fra.cloud.appwrite.io/v1') // Your cloud Appwrite endpoint
  .setProject('68629192002b272deda6'); // Your cloud Appwrite project ID

const cloudStorage = new Storage(cloudAppwriteClient);

export default cloudAppwriteClient;
export { cloudStorage }; 